import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '@aimsos/auth';
import { DashboardProviderWrapper } from './context';
import DashboardsListPage from './pages/DashboardsListPage.jsx';
import DashboardTemplatesPage from './pages/DashboardTemplatesPage.jsx';
import DashboardDetailPage from './pages/DashboardDetailPage.jsx';
import DashboardNewPage from './pages/DashboardNewPage.jsx';

/**
 * Domain root for Dashboards.
 * Owns its internal routes and will wrap with providers when needed.
 *
 * Paths are RELATIVE to the parent route that mounts this component:
 *   - Shell:      <Route path="dashboards/*">
 *   - Standalone: <Route path="dashboards/*"> in main.jsx
 */
const Dashboards = () => (
  <DashboardProviderWrapper>
    <Routes>
      <Route
        index
        element={
          <ProtectedRoute>
            <DashboardsListPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="templates"
        element={
          <ProtectedRoute>
            <DashboardTemplatesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path=":dashboardId"
        element={
          <ProtectedRoute>
            <DashboardDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path=":dashboardId/edit"
        element={
          <ProtectedRoute>
            <DashboardNewPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="new"
        element={
          <ProtectedRoute>
            <DashboardNewPage />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="" replace />} />
    </Routes>
  </DashboardProviderWrapper>
);

export default Dashboards;
